import { ContainerModule } from 'inversify';
import { PracticeSessionService, PracticeSessionServiceSymbol } from './practice-session-service'

export const practiceSessionServiceModule = new ContainerModule((bind) => {
  bind(PracticeSessionServiceSymbol).to(PracticeSessionService).inSingletonScope();
});
